import { render, staticRenderFns } from "./EditVacation.vue?vue&type=template&id=0febb353&"
import script from "./EditVacation.vue?vue&type=script&lang=js&"
export * from "./EditVacation.vue?vue&type=script&lang=js&"
import style0 from "./EditVacation.vue?vue&type=style&index=0&id=0febb353&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports